<div class="back-button-container">
  <app-back-button [routerLink]="'/'" fragment="articles"></app-back-button>
</div>

@if (selectedArticle) {
  <div class="article-container">
    <h1>{{ selectedArticle.title }}</h1>
    @if (selectedArticle.image) {
      <div class="article-image">
        <img [src]="selectedArticle.image" [alt]="selectedArticle.imageAlt || selectedArticle.title" />
      </div>
    }
    <div class="article-content" [innerHTML]="articleContents"></div>
  </div>

  <div class="back-button-container back-button-bottom mobile-only">
    <app-back-button [routerLink]="'/'" fragment="articles"></app-back-button>
  </div>
}

@if (!selectedArticle) {
  <div class="article-container">
    <p>Articolul nu a fost găsit.</p>
  </div>
}
